var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { namespace } from 'vuex-class';
import Vue from 'vue';
import Component from 'vue-class-component';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { GATE_HEIGHT_TRAD_KEYS, GATE_IS_MOTORIZED_CHOICES, GATE_WIDTH_TRAD_KEYS, } from '@shared/constants/breakInDamages/GateConstants';
import { objectToTranslatableChoices } from '@shared/choice';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let GateSizeAndMotorization = class GateSizeAndMotorization extends Vue {
    constructor() {
        super(...arguments);
        this.showValidation = false;
        this.GATE_WIDTH_CHOICES = objectToTranslatableChoices(GATE_WIDTH_TRAD_KEYS);
        this.GATE_HEIGHT_CHOICES = objectToTranslatableChoices(GATE_HEIGHT_TRAD_KEYS);
        this.GATE_MOTORIZATION_CHOICES = GATE_IS_MOTORIZED_CHOICES;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return (!this.validation.fieldHasViolations('gateWidth') &&
            !this.validation.fieldHasViolations('gateHeight') &&
            !this.validation.fieldHasViolations('gateIsMotorized'));
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], GateSizeAndMotorization.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], GateSizeAndMotorization.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], GateSizeAndMotorization.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], GateSizeAndMotorization.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], GateSizeAndMotorization.prototype, "validateBreakInDamage", void 0);
GateSizeAndMotorization = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], GateSizeAndMotorization);
export default GateSizeAndMotorization;
